module.exports = __webpack_public_path__ + "img/asc.5a512f43.svg";